import { useEffect, useState } from 'react';

import { NutritionCustomerSuccessInfo } from '../../../../../interfaces/NutritionCustomerSuccessInfo';
import { nutritionHomeService } from '../../../../../services/nutritionHomeService';

type UseNutritionCustomerSuccessReturn = {
  customerSuccess: NutritionCustomerSuccessInfo | null;
};

export const useNutritionCustomerSuccess = (): UseNutritionCustomerSuccessReturn => {
  const [customerSuccess, setCustomerSuccess] =
    useState<NutritionCustomerSuccessInfo | null>(null);

  const fetchCustomerSuccess = async () => {
    const data = await nutritionHomeService.getCustomerSuccess();
    setCustomerSuccess(data);
  };

  useEffect(() => {
    fetchCustomerSuccess();
  }, []);

  return { customerSuccess };
};
